import { Component, Input, ViewEncapsulation, ElementRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

/**
 * inputs:
 * -------
 * input label?: string
 * input placeholder?: string
 * input mandatory?: boolean
 * input formName?: string
 * input type text|email|phone|credit-card|cvc|password|custom
 * input customValidation? regexp|method
 * input noteText?: string
 * input isDisabled?: boolean
 * input setFocus?: boolean
 * input errorMessage?: string
 * input showError?: boolean
 * ---------------------------
 * events:
 * -------
 * output focused
 * output blured
 * output clicked
 * output changed
 * output validationError
 */

@Component({
  selector: 'ops-input-preview',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './ops-input-preview.component.html',
  styleUrl: './ops-input-preview.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class OpsInputPreviewComponent {
  @Input() label?: string;
  @Input() isPreview?: boolean = false;
  @Input() isDisabled?: boolean = false;

  @Input() type?: string;

  @Input() noteText?: string;

  @Input() extendClass?: string;

  @Input() textOnly?: boolean;

  private _value = '';

  @Input() set value(val: string) {
    if (this.type === 'date') {
      this._value = this.datePreview(new Date(val));
    } else {
      this._value = val;
    }
  }
  get value(): string {
    return this._value;
  }

  datePreview = (val: Date) => {
    const dateCover = val.getDate();
    const monthCover = val.getMonth() + 1;

    return (
      (dateCover < 10 ? '0' + dateCover : dateCover) +
      '.' +
      (monthCover < 10 ? '0' + monthCover : monthCover) +
      '.' +
      val.getFullYear()
    );
  };

  constructor(private el: ElementRef) {}
}
